import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { HubPreviewFooterProps } from '../src/hub-view/HubPreviewFooter.tsx';

export const HubPreviewFooter: LoadableType<HubPreviewFooterProps> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-HubPreviewFooter" */ '../src/hub-view/HubPreviewFooter.tsx'
			)
		).HubPreviewFooter,
});
